// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuikit from "vuikit";
import VuikitIcons from "@vuikit/icons";
import "@vuikit/theme";
import DatePicker from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
const VueInputMask = require("vue-inputmask").default;
import vueHeadful from "vue-headful";
import App from "./App";
import router from "./router";
import axios from "axios";

var VueCookie = require("vue-cookie");

Vue.use(VueCookie);
Vue.use(Vuikit);
Vue.use(VuikitIcons);

locale.use(lang);
Vue.use(DatePicker);

Vue.use(VueInputMask);

Vue.component("vue-headful", vueHeadful);

axios.defaults.baseURL = process.env.API_BASE_URL;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router: router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js